import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Icon from '../../../../components/Icon';
import Label from '../../../../components/Label';
import './styles.css';

const FieldError = (props) => {
  const { message } = props;
  return (
    <Label role="tooltip" basic color="red" pointing data-cy="Premium-Hem-Field-Error">
      <Icon name="exclamation circle" styleName="validationError" size="large" />
      <FormattedMessage {...message} />
    </Label>
  );
};

FieldError.propTypes = {
  message: PropTypes.object.isRequired,
};

export default FieldError;
